import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import Modal from '@dbk/ui-modal';
import BlurModal from '../../../components/common/blur-modal';
import { DOCSIGN_CONSTANTS } from '../../../constants';
import Loading from '../../../components/common/loading/loading-circle';
import DocumentSigner from './document-signer';

class DocusignModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      docusignModallVisible: true,
      allPagesRead: false,
      confirmTitle: '',
      confirmationString: '',
      onConfirmFunc: () => { },
      urlReceived: false,
      action: ''
    };
    this.closeModal = this.closeModal.bind(this);
    this.docusignEvent = this.docusignEvent.bind(this);

  }

  componentWillMount() {
    if (this.props.document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION ||
      this.props.document.signStatus === 'Pending') {
      this.props.getDocuSignWebURL(this.props.document.dwoDocSid)
    } else {
      this.props.getSignedDocument(this.props.document.dwoDocSid);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION ||
      this.props.document.signStatus === 'Pending') {
      if (prevProps.docusignaccept.docuSignURLResponse !== this.props.docusignaccept.docuSignURLResponse) {
        this.setState({
          urlReceived: true
        })
      }
    } else {
      if (prevProps.docusignaccept.signedDocumentResponse !== this.props.docusignaccept.signedDocumentResponse) {
        this.setState({
          urlReceived: true
        })
      }
    }
  }

  componentWillUnmount() {
    this.props.setdocuSignURLResponseError('');
    this.props.setcompleteDocumentSignResponseError('');
    this.props.setSignedDocumentResponseError('');
    if (this.state.action !== DOCSIGN_CONSTANTS.CANCEL) {
      this.props.rsa.onChangePage('/docsign/docusign-response-modal');
    }
  }

  closeModal() {
    this.props.setUserAction(DOCSIGN_CONSTANTS.CANCEL);
    this.setState({
      action: DOCSIGN_CONSTANTS.CANCEL
    })
    if (this.props.document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION ||
      this.props.document.signStatus === 'Pending') {
      const { docusignaccept: { docuSignURLResponse, docuSignURLResponseError } } = this.props;
      if (!docuSignURLResponseError && docuSignURLResponse) {
        this.props.completeDocumentSign(
          docuSignURLResponse.data.txId,
          DOCSIGN_CONSTANTS.CANCEL,
          this.props.document.docName
        );
      }
      this.props.docusignaccept.setShowDocusignModal(false);
    } else {
      this.props.docusignaccept.setShowDocusignModal(false);
    }
  }

  docusignEvent(pdfStatus) {
    let userAction;
    if (pdfStatus.status == DOCSIGN_CONSTANTS.DOCUSIGN_SIGNING_COMPLETE) {
      userAction = DOCSIGN_CONSTANTS.DOCUSIGN_SIGNING_COMPLETE
    } else if (pdfStatus.status == DOCSIGN_CONSTANTS.DOCUSIGN_DECLINE) {
      userAction = DOCSIGN_CONSTANTS.DOCUSIGN_DECLINE
    } else if (pdfStatus.status == DOCSIGN_CONSTANTS.DOCUSIGN_ACCESS_CODE_FAILED) {
      userAction = DOCSIGN_CONSTANTS.DOCUSIGN_ACCESS_CODE_FAILED
    } else if (pdfStatus.status == DOCSIGN_CONSTANTS.DOCUSIGN_CANCEL) {
      userAction = DOCSIGN_CONSTANTS.DOCUSIGN_CANCEL
    } else if (pdfStatus.status == DOCSIGN_CONSTANTS.DOCUSIGN_TTL_EXPIRED) {
      userAction = DOCSIGN_CONSTANTS.DOCUSIGN_TTL_EXPIRED
    }
    const { docusignaccept: { docuSignURLResponse } } = this.props;
    this.props.setUserAction(userAction);
    this.props.setDocumentName(this.props.document.docName);
    this.props.docusignaccept.setShowDocusignModal(false);
    //this.props.completeDocumentSign(docuSignURLResponse.data.txId, userAction, this.props.document.docName);
  }

  render() {
    const {
      docusignaccept: {
        docuSignURLResponse,
        docuSignURLResponseError,
        completeDocumentSignResponseError,
        signedDocumentResponse,
        signedDocumentResponseError,
      },
      document,
      i18n: { messages }
    } = this.props;

    if (!this.state.urlReceived) {
      return (
        <BlurModal
          visible
          backVisible
          doneVisible={false}
          onBackPress={this.closeModal}
          title={document.docName}
          onDone={this.closeModal}
          size='large'
        >
          <div className="padding-top-50 padding-bottom-50">
            <Loading />
            <Text className="center-content" secondary> {messages['app.docusign.digisign.downloadingDocument']}</Text>
          </div>
        </BlurModal>
      )
    }

    if (signedDocumentResponse && !signedDocumentResponseError) {
      this.closeModal();
    }

    return (
      <Modal
        isActive
        disableOutsideClick
        onClose={this.closeModal}
        header={document.docName}
        size='large'
        content={
          <div>
            {docuSignURLResponseError !== '' && docuSignURLResponseError !== undefined && docuSignURLResponseError !== null &&
              <Text className="center-content" secondary>{docuSignURLResponseError}</Text>
            }
            {signedDocumentResponseError !== '' && signedDocumentResponseError !== undefined && signedDocumentResponseError !== null &&
              <Text className="center-content" secondary>{signedDocumentResponseError}</Text>
            }
            {document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION ?
              !docuSignURLResponseError && !completeDocumentSignResponseError && !signedDocumentResponseError &&
              <DocumentSigner
                pdfUrl={docuSignURLResponse.data.url}
                onPdfSubmit={this.docusignEvent}
              />
              :
              <div />
            }
          </div>
        }
      />
    )
  }
}

export default createContainer({
  $queries: {
    i18n: { messages: true },
    rsa: {
      onChangePage: {
        $call: 'changePage',
      },
    },
    setRsaPageName: { $set: 'ui.state.rsaPageName' },
    acceptsign: {
      acceptViewResponse: true,
      actionAcceptResponse: true,
      acceptViewResponseError: true,
      actionAcceptResponseError: true,
      actionAcceptResponseSuccess: true
    },
    getAcceptView: { $call: 'acceptsign.getAcceptView' },
    getActionAccept: { $call: 'acceptsign.getActionAccept' },
    setDataForRejection: { $call: 'acceptsign.setDataForRejection' },
    docusignaccept: {
      docuSignURLResponse: true,
      docuSignURLResponseError: true,
      completeDocumentSignResponse: true,
      completeDocumentSignResponseError: true,
      signedDocumentResponse: true,
      signedDocumentResponseError: true,
      setShowDocusignModal: { $set: 'showDocusignModal' },
    },
    setUserAction: { $set: 'docusignaccept.signAction' },
    setDocumentName: { $set: 'docusignaccept.documentName' },
    getDocuSignWebURL: { $call: 'docusignaccept.getDocuSignWebURL' },
    completeDocumentSign: { $call: 'docusignaccept.completeDocumentSign' },
    getSignedDocument: { $call: 'docusignaccept.getSignedDocument' },
    setSignedDocumentResponseError: { $set: 'docusignaccept.signedDocumentResponseError' },
    setdocuSignURLResponseError: { $set: 'docusignaccept.docuSignURLResponseError' },
    setcompleteDocumentSignResponseError: { $set: 'docusignaccept.completeDocumentSignResponseError' },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      }
    }
  },
})(DocusignModal);
